import {
  Content as AlertDialogContent,
  Action as _Action,
  Cancel as _Cancel,
  Overlay as _Overlay,
  Title as _Title,
} from '@radix-ui/react-alert-dialog'
import React from 'react'

import { css, styled } from 'design'
import { ButtonProps, buttonStyles } from 'primitives/button'
import { cn } from 'util/cn'

// Export unstyled items
export { Root } from '@radix-ui/react-alert-dialog'

export const Overlay = styled(_Overlay, {
  background: 'rgba(0, 0, 0, .3)',
  position: 'fixed',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
})

const StyledContent = styled(AlertDialogContent, {
  position: 'fixed',
  minWidth: '20vw',
  width: '90%',
  top: '50%',
  left: '10%',
  transform: 'translate(-5%, -50%)',
  color: '$foreground',
  backgroundColor: '$backgroundSecondary',
  border: '1px solid $grey200',
  padding: '$4',
  fontSize: '$2',
  boxShadow: '$2',
  borderRadius: '$3',

  '@md': {
    width: 'auto',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
})

export const Content = ({
  className,
  children,
  css,
  ...props
}: React.ComponentProps<typeof AlertDialogContent>) => {
  return (
    <StyledContent
      className={className}
      css={css as any}
      {...props}
    >
      {children}
    </StyledContent>
  )
}

export const Title = styled(_Title, {
  margin: '0 0 $4',
})

const actionStyles = css({
  minWidth: 100,
})

export const Action = ({
  className,
  children,
  variant = 'primary',
  toggled,
  size,
  shape,
  ...props
}: React.ComponentProps<typeof _Action> & ButtonProps) => (
  <_Action
    className={cn(
      className,
      actionStyles(),
      buttonStyles({ variant, toggled, size, shape }),
    )}
    {...props}
  >
    {children}
  </_Action>
)

export const Cancel = ({
  className,
  children,
  variant = 'secondary',
  toggled,
  size,
  shape,
  ...props
}: React.ComponentProps<typeof _Cancel> & ButtonProps) => {

  return (
    <_Cancel
      className={cn(
        className,
        actionStyles(),
        buttonStyles({ variant, toggled, size, shape }),
      )}
      {...props}
    >
      {children}
    </_Cancel>
  )
}
